<template>
  <div class="create-team">
    <div class="btn-wrapper mb-10 mr-20 move-right">
      <router-link to="/admin/hrm/leave/all" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      v-loading="loading"
      :model="leaveForm"
      :rules="rules"
      ref="leaveForm"
      class="white-bg form"
      label-position="left"
      label-width="160px"
    >
      <h3 class="text-gray bold mt-0 mb-40">Create New Leave</h3>
      <div class="mt-20">
        <el-form-item prop="employee_id" label="Employee Name">
          <el-select
            v-model="leaveForm.employee_id"
            placeholder="Select"
            name="employees"
            filterable
            remote
            :remote-method="searchEmployees"
            @change="fetchLeaveTypes"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="leave_type_id" label="Leave Type">
          <el-select
            v-model="leaveForm.leave_type_id"
            placeholder="Select Leave Type"
            name="leave_type_id"
            :loading="leaveTypesLoading"
            :disabled="!leaveForm.employee_id || leaveTypesLoading"
          >
            <el-option
              v-for="item in employeeLeave"
              :key="item.id"
              :label="item.leave_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="start_date" label="Leave Date">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="note" label="Reason">
          <el-input
            type="textarea"
            :rows="5"
            placeholder
            v-model="leaveForm.note"
          ></el-input>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="handover_to" label="Relief Staff">
          <el-select
            v-model="leaveForm.handover_to"
            placeholder="Employee name"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="create()"
            :loading="loading"
            >Create</el-button
          >
          <el-button
            class="btn btn-light-gray no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click="$router.go(-1)"
            >Cancel</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    return {
      leaveForm: {
        employee_id: null,
        start_date: null,
        end_date: null,
        handover_to: "",
        leave_type_id: null,
        note: "",
      },
      employees: [],
      date: "",
      loading: false,
      leaveTypesLoading: false,
      rules: {
        employee_id: [
          {
            required: true,
            message: "Please input employee name",
            trigger: "blur",
          },
        ],
        start_date: [
          {
            required: true,
            message: "Please select leave dates",
            trigger: "change",
          },
        ],
        leave_type_id: [
          {
            required: true,
            message: "Please input leave type ",
            trigger: "blur",
          },
        ],
        note: [
          { required: true, message: "Please input note ", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["employeeLeave"]),
  },
  watch: {
    date: function(val) {
      this.leaveForm.start_date = val ? val[0] : null;
      this.leaveForm.end_date = val ? val[1] : null;
    },
  },
  methods: {
    ...mapActions(["getLeaveById", "createLeave", "getLeaveByEmployee"]),
    async fetchLeaveTypes(id) {
      this.leaveForm.leave_type_id = null;
      this.leaveTypesLoading = true;
      try {
        await this.getLeaveByEmployee(id);
      } catch (error) {
        return;
      } finally {
        if (this.leaveForm.employee_id === id) this.leaveTypesLoading = false;
      }
    },
    create() {
      this.$refs[`leaveForm`].validate(valid => {
        if (valid) {
          if (this.leaveForm.handover_to === "") {
            this.leaveForm.handover_to = 0;
          }
          this.loading = true;
          const inputData = this.leaveForm;
          this.$store
            .dispatch("admin/hrm/leave/createLeave", inputData)
            .then(() => {
              this.loading = false;
              this.$router.push({ path: "all" });
            })
            .catch(error => {
              this.loading = false;
              this.leaveForm.handover_to = "";
              this.$notification("error", error.message);
            });
        }
      });
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>
<style scoped>
.el-range-editor.el-input__inner {
  width: 100% !important;
  border: 1px solid #888 !important;
}
</style>
